import type { FC } from 'react'
// import cornerSVG from '@/assets/corner.svg'
import { cx } from 'cva'

type CornerProps = {
	className?: string
}

export const Corner: FC<CornerProps> = ({ className }) => {
	return (
		<div
			className={cx(
				'aspect-ratio-square pointer-events-none absolute top-0 right-0 z-10 w-object-corner',
				className,
			)}
			aria-hidden="true"
		>
			<svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
				<title>Corner</title>
				{/* <use href={`${cornerSVG.src}#asset-corner`} /> */}
				<path
					d="M80 80C79.9606 71.2492 76.4751 62.8655 70.2959 56.6748L23.4326 9.72461C17.2181 3.49859 8.78864 0.000976562 0 0.000976562H80V80Z"
					fill="currentColor"
				/>
			</svg>
		</div>
	)
}
